module.exports = __webpack_public_path__ + "media/product/p-4-6159d8a3.png";